export const GET_RESOURCES = 'GET_RESOURCES'
export const GET_RESOURCE = 'GET_RESOURCE'
export const ADD_RESOURCE = 'ADD_RESOURCE'
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE'
export const DELETE_RESOURCE = 'DELETE_RESOURCE'

export const GET_RESOURCE_SIGNED_UPLOAD_URL = 'GET_RESOURCE_SIGNED_UPLOAD_URL'
export const CONFIRM_RESOURCE_FILE_UPLOAD = 'CONFIRM_RESOURCE_FILE_UPLOAD'
export const RESOURCE_DELETE_FILE = 'RESOURCE_DELETE_FILE'
